import React from "react";
import { useParams } from "react-router-dom";
import AuthorProfile from "../../componets/AuthorProfile";

// Dummy data (can be replaced with API later)
const authors = {
  haider: {
    image: "/assets/user.jpg",
    name: "Haider Shah",
    role: "SEO Specialist",
    about: "As a technical SEO writer with a web development background, I create content that bridges the gap between complex technical topics and effective search optimization. My expertise in web development allows me to explain intricate concepts in a clear, practical way, helping businesses improve their site's performance and search rankings.",
    stats: [
      { label: "Tutorials written", value: 0, link: "#" },
      { label: "Tutorials visited", value: 0, link: "#" },
      { label: "Blog posts written", value: 3, link: "#" },
    ],
    social: {
      linkedin: "https://www.linkedin.com/in/haidershah818",
      facebook: "https://www.facebook.com/share/1D72SeyXgC/",
    },
  },
  faiz: {
    image: "https://via.placeholder.com/150/0000FF/FFFFFF",
    name: "Muhammad Faiz",
    role: "Developer & Blogger",
    about: "Faiz is a full-stack developer and blogger, sharing tutorials and tips to help developers grow their skills.",
    stats: [
      { label: "Tutorials written", value: 5, link: "#" },
      { label: "Tutorials visited", value: 20, link: "#" },
      { label: "Blog posts written", value: 6, link: "#" },
    ],
  },
  saad: {
    image: "/assets/user.jpg",
    name: "Saad Ali Khan",
    role: "SEO Specialist",
    about: "As a technical SEO writer with a web development background, I create content that bridges the gap between complex technical topics and effective search optimization. My expertise in web development allows me to explain intricate concepts in a clear, practical way, helping businesses improve their site's performance and search rankings.",
    stats: [
      { label: "Tutorials written", value: 0, link: "#" },
      { label: "Tutorials visited", value: 0, link: "#" },
      { label: "Blog posts written", value: 3, link: "#" },
    ],
  },
};

export default function UserProfilePage() {
  const { username } = useParams();
  const user = authors[username];

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xl">
        User not found 😢
      </div>
    );
  }

  return (
    <AuthorProfile
      image={user.image}
      name={user.name}
      role={user.role}
      about={user.about}
      stats={user.stats}
      social={user.social} // <-- new prop for social links
    />

  );
}
